module.exports = __webpack_public_path__ + "media/images/front/sp/dummy/doctor02-7411605b397be5a87686259207e351ed.png";